/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { takeLatest, ForkEffect, take } from 'redux-saga/effects';
import ActionConstants from '../constants/';
import workerSaga from './workerSaga';

// ------------------------------------
// Watchers
// ------------------------------------
export default function* bpclWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLatest(ActionConstants.GET_ALL_MERCHANT_STAGE_LIST, workerSaga);
  yield takeLatest(ActionConstants.GET_PENDING_MERCHANT_STAGE_LIST, workerSaga);
  yield takeLatest(ActionConstants.GET_REVIEW_REQUESTS, workerSaga);
  yield takeLatest(ActionConstants.UPDATE_REVIEW_REQUESTS, workerSaga);
  yield takeLatest(ActionConstants.UPLOAD_BULK_MERCHANT_DATA, workerSaga);
  yield takeLatest(ActionConstants.DOWNLOAD_BULK_MERCHANT_TEMPLATE, workerSaga);
  yield takeLatest(ActionConstants.GET_BPCL_BULK_UPLOAD_HISTORY, workerSaga);
}
